import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import './scss/main.scss';
import i18n from './i18n';
import { saveSpanishLanguagePreference } from './store/action/OrderAction';
import { detectLangFromHash } from './util/languageDetect';

const applyLanguage = () => {
  const lang = detectLangFromHash();
  sessionStorage.setItem('elnk_lang', lang);
  i18n.changeLanguage(lang);
  store.dispatch(saveSpanishLanguagePreference(lang === 'es'));
};

// Run on initial load
applyLanguage();

// Re-run on hash change (same-tab URL paste doesn't trigger a full reload in HashRouter)
window.addEventListener('hashchange', applyLanguage);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
    <App />
    {/* </React.StrictMode> */}
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
